import API from "../..";
import { fullUrl } from "../../utile/utile.api";

export type UserData = {
  company: {
    /** ○	企業名 */
    name: string,
    /** ○	システム管理フラグ false:非管理者 true:管理者 */
    system_admin_flag: boolean,
    /** ○	初回ログイン時のパスワード変更が必要か表すフラグ（trueで必要） */
    password_change_required_flag: boolean,
  }
}

const path = '/is-login';

const isLogin = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    get: () => API.con.get<{}, UserData>({ url: full, data: {} }),
  })
}

export default isLogin;